// extracted by mini-css-extract-plugin
export default {"socials":"Socials_socials__4+FJH","socials__item":"Socials_socials__item__zqAza","socials__link":"Socials_socials__link__EARaE","socials__icon":"Socials_socials__icon__DQeo5"};